/** Stable code callers can switch on without an instanceof check. */
export const CONFIRMATION_DECLINED = 'confirmation-declined' as const;

export type ConfirmationDeclineReason = 'cancelled' | 'timeout';

/**
 * Rejection raised by OverlayConfirmationService.confirm when the user
 * explicitly cancels the confirmation overlay or its 120s timeout fires.
 * Distinguishable from transport/keycloak failures via instanceof or
 * `error.code === CONFIRMATION_DECLINED`.
 */
export class ConfirmationDeclinedError extends Error {
  public readonly code = CONFIRMATION_DECLINED;

  constructor(
    public readonly reason: ConfirmationDeclineReason,
    public readonly claimType: string,
    operation?: string,
  ) {
    super(
      `confirmation-declined: ${reason} while confirming claim '${claimType}'` +
        (operation ? ` for '${operation}'` : ''),
    );
    this.name = 'ConfirmationDeclinedError';
  }
}
